import React from 'react';
interface SegmentedProps<T extends string> {
  label: string;
  value: T;
  options: {
    value: T;
    label: string;
  }[];
  onChange: (value: T) => void;
}

/** Small radio-group for one choice out of a few. */
export function Segmented<T extends string>({
  label,
  value,
  options,
  onChange
}: SegmentedProps<T>) {
  return <div role="radiogroup" aria-label={label} className="inline-flex rounded-full bg-white/[0.05] p-1" data-id="element-403" data-mp="1k022czi0q7f7">
      {options.map(o => {
      const active = o.value === value;
      return <button key={o.value} type="button" role="radio" aria-checked={active} onClick={() => onChange(o.value)} className={`whitespace-nowrap rounded-full px-3 py-1.5 text-[13px] font-medium transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/60 ${active ? 'bg-white/[0.12] text-ink' : 'text-ink-muted hover:text-ink'}`} data-id="element-404" data-mp="1tploqf4xwjet">
            {o.label}
          </button>;
    })}
    </div>;
}